import moment from 'moment';
import { debug } from '../utils';

/**
 * Gpay /getPhoneNumber API call to get user's phone number from GPAY app
 * @returns {object} apiResponse - Response from GPAY /getPhoneNumber API
 */
export const invokeGpayPhoneSpotAPI = async () => {
  debug('INFO', 'Initiating invokeGpayPhoneSpotAPI ...');

  const request = { nonce: 'nonce typically generated server-side' };
  // if (skipPrompt) {
  //   request.skipPrompt = true;
  // }

  let responseToReturn = {};

  const phoneApiResponse = await microapps
    .getPhoneNumber(request)
    .then((response) => {
      const decodedPhoneNoObj = JSON.parse(atob(response.split('.')[1]));
      debug('RESPONSE', `GPAY /getPhoneNumber`, decodedPhoneNoObj);
      responseToReturn.statusCode = 200;
      responseToReturn.body = decodedPhoneNoObj;
      return responseToReturn;
    })
    .catch((error) => {
      debug('ERROR', error);
      responseToReturn.statusCode = 500;
      responseToReturn.body = {};
      return responseToReturn;
    });

  debug('FINAL RETURN', `GPAY /getPhoneNumber`, phoneApiResponse);
  return phoneApiResponse;
};
